// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"645":"85407d05","685":"1d6669eb","786":"72882909","899":"72882909","926":"10b41df6"}[chunkId] + ".css";
};